import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, getCurrentInstance, onMounted } from 'vue';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import type { TimeslotFormData } from '@white-label-types/component';
import SearchTimeslotEditForm from '../search-timeslot-edit-form/search-timeslot-edit-form.vue';
import { NAMED_ROUTES } from '@white-label-configuration/constants';
import { searchPusherHelper } from '@white-label-helper/pusher-helper-search';
import { extractFlights } from 'ecommerce/shared-helpers';
import { datadogRum } from '@datadog/browser-rum';
import Vue from 'vue/types/umd';
import { guessTimezone } from '@white-label-helper/date-utilities';
import { FlightInfo } from '@white-label-types/search-box';
import { gaDataLayerTimeslotHome } from '@white-label-helper/ga-data-layer';
import { pushToRouter } from '@white-label-helper/router';
import { getFeatureFlag } from '@white-label-plugin/launch-darkly';


export default /*#__PURE__*/_defineComponent({
  __name: 'search-box-timeslot',
  setup(__props) {

let $vueInstance: Vue|null = null;

const formData: Ref<TimeslotFormData> = ref({
  passengers: 1,
  departureDate: '',
});

const flights: Array<object> = ref([]);
const flightsRequestStatus: Ref<'empty'|'loading'|'success'|'error'> = ref('empty');
const apiRequestRunning: Ref<boolean> = ref(false);
const updatingSearch: Ref<boolean> = ref(false);
const selectedFlight: Ref<FlightInfo | {}> = ref({});

const partnerTimeZone = computed((): string => getAppVariable('poi.timezone') || guessTimezone());

const updateSearch = (payload: TimeslotFormData): void => {
  $vueInstance?.$gtm.push(gaDataLayerTimeslotHome({ numberOfGuest: payload.passengers }));
  pushToRouter({ path: NAMED_ROUTES.search, query: payload });
};


onMounted(() => {
  $vueInstance = getCurrentInstance().proxy;
});

const showTechnicalIssueModal = (): void => {
  // Timeout to help with animation & UX on try again button click.
  setTimeout(() => {
    // @ts-ignore
    $vueInstance.$openModal('GlobalModalError', {
      header: $vueInstance.$t('shared.modals.errors.preloaderError'),
      body: $vueInstance.$t('UI.modalError.tryAgainOrGoHome'),
      buttons: [
        {
          btnText: $vueInstance.$t('shared.buttons.close'),
        },
      ],
    });
  }, 500);
};

const onDepartureDateSelect = (payload: TimeslotFormData): void => {
  $vueInstance?.$gtm.push(gaDataLayerTimeslotHome({ flightDepartureDate: payload.departureDate }));
  selectedFlight.value = {};
  flights.value = [];
  flightsRequestStatus.value = 'loading';

  const searchHelper = searchPusherHelper();

  const form = {
    entryDate: payload.departureDate,
    entryTime: ({ name: '', value: '23:59' }),
    customers: {
      adult: 1,
    },
    meta: {
      step: "step1"
    }

  };
  searchHelper.searchProducts({ ...form }, 'fasttrack', $vueInstance.$i18n.locale)
    .then((rawFlightData) => {
      flights.value = extractFlights(rawFlightData);
      flightsRequestStatus.value = 'success';
    })
    .catch((error: any) => {
      console.log(error);
      datadogRum.addError(error);
      flightsRequestStatus.value = 'error';
      showTechnicalIssueModal();
    });
};

const onFlightChange = (flight: FlightInfo): void => {
  if (flight && Object.keys(flight).length > 0) {
    $vueInstance?.$gtm.push(gaDataLayerTimeslotHome({
      terminal: flight?.terminal,
      airline: flight?.airline,
      flightDepartureDate: JSON.parse(JSON.stringify(formData.value)).departureDate,
      flightDepartureTime: flight?.time
    }));
  }
  selectedFlight.value = flight;
};

const showTwoTerminalsInfo = getFeatureFlag('CRO_989_TIMESLOT_SHOW_TWO_TERMINALS_MESSAGE', false);

return { __sfc: true,$vueInstance, formData, flights, flightsRequestStatus, apiRequestRunning, updatingSearch, selectedFlight, partnerTimeZone, updateSearch, showTechnicalIssueModal, onDepartureDateSelect, onFlightChange, showTwoTerminalsInfo, SearchTimeslotEditForm }
}

})